import React from 'react';

/**
 * Bottom CTA banner with gradient background.
 *
 * Props:
 *   heading   - main heading (can include <br />)
 *   subtitle  - supporting text
 *   ctas      - array of { label, href, variant: 'primary'|'white-outline' }
 */
const FinalCTA = ({ heading, subtitle, ctas = [] }) => {
  return (
    <section className="rr-final-cta">
      <div className="rr-final-cta__inner">
        <div>
          {heading && <h2 className="rr-final-cta__h2">{heading}</h2>}
          {subtitle && <p className="rr-final-cta__sub">{subtitle}</p>}
        </div>
        {ctas.length > 0 && (
          <div className="rr-final-cta__btns">
            {ctas.map((cta, i) => (
              <a
                key={i}
                href={cta.href}
                className={
                  cta.variant === 'white-outline'
                    ? 'rr-cta-white-outline'
                    : 'rr-cta-primary'
                }
              >
                {cta.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FinalCTA;
